module.exports = __webpack_public_path__ + "static/tui_logo.034a121f.svg";